"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownHeadingMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _iconOffsetMixin = require("../iconOffsetMixin");
var _marginMixin = require("../marginMixin");
var _spaceMixin = require("../spaceMixin");
var _typographyMixin = require("../typographyMixin");
var DropdownHeadingMixin = function DropdownHeadingMixin(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'DropdownHeading.backgroundColor',
    fontColor: 'DropdownHeading.fontColor',
    fontType: 'DropdownHeading.fontType',
    horizontalSpacing: 'DropdownHeading.horizontalSpacing',
    iconMarginRight: 'DropdownHeading.Icon.marginRight',
    iconSize: 'DropdownHeading.iconSize',
    margin: 'DropdownHeading.margin',
    verticalSpacing: 'DropdownHeading.verticalSpacing'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      fontColor = _ref.fontColor,
      fontType = _ref.fontType,
      horizontalSpacing = _ref.horizontalSpacing,
      iconMarginRight = _ref.iconMarginRight,
      iconSize = _ref.iconSize,
      verticalSpacing = _ref.verticalSpacing;
    return (0, _styledComponents.css)(["", " ", " background-color:", ";box-sizing:border-box;color:", ";margin:0;padding:", "px ", "px;text-transform:uppercase;&:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit;}", " > ", "{color:", ";flex-shrink:0;margin-right:", ";}"], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType,
      fontTypeIconAlignment: false
    }, props)), (0, _iconOffsetMixin.iconOffsetMixin)(Object.assign({}, props, {
      iconSize: iconSize
    })), backgroundColor, fontColor, verticalSpacing, horizontalSpacing, (0, _marginMixin.marginMixin)(props), _Icon.StyledIcon, fontColor, iconMarginRight ? iconMarginRight + "px" : (0, _spaceMixin.spaceMixin)('xs')(props));
  })(props);
};
exports.DropdownHeadingMixin = DropdownHeadingMixin;